function getFuelBrand(brands) {
  return brands.length ? brands.find(b => b.branding_type === 'fuel') : undefined;
}

function getCstoreBrand(brands) {
  return brands.length ? brands.find(b => b.branding_type === 'cstore') : undefined;
}

const getFuelBrandName = brands => ((getFuelBrand(brands) || {}).name || '').trim();

const getCstoreBrandName = brands => ((getCstoreBrand(brands) || {}).name || '').trim();

function getStationDisplayName(brands, stationName) {
  if (brands?.length === 2) {
    const [firstBrand, secondBrand] = brands;
    if (firstBrand.brand_id === secondBrand.brand_id) {
      return firstBrand.name;
    }

    const fuelBrandName = getFuelBrandName(brands);
    const cstoreBrandName = getCstoreBrandName(brands);

    if (!fuelBrandName || !cstoreBrandName) {
      return stationName;
    }
    return `${fuelBrandName} & ${cstoreBrandName}`;
  }

  return stationName;
}

function getBrandMatchesForStationBrands(stationBrandings = [], brands) {
  return stationBrandings?.map(branding => ({
    branding_type: 'cstore',
    ...brands.find(brand => brand.brand_id === branding.brand_id),
    ...branding,
  }));
}

export {
  getFuelBrand,
  getFuelBrandName,
  getCstoreBrand,
  getCstoreBrandName,
  getStationDisplayName,
  getBrandMatchesForStationBrands,
};
